rdefine('app/products/collections/Properties',['backbone'],function(Backbone) {
    var Property = Backbone.Ribs.Model.extend({});
    return Backbone.Ribs.Collection.extend({
        model: Property,
        lastCid:null,
        loadProperties:function(cat_id) {
            this.lastCid = cat_id;
            $.getJSON(window.categoriesurl, {
                category_id:cat_id
            },function(item){
                this.reset(item);
            }.bind(this));
        },
        reloadProperties:function() {
            this.loadProperties(this.lastCid);
        }
    });
});